import { render } from "./AgendaTable.vue?vue&type=template&id=56706b30"
import script from "./AgendaTable.vue?vue&type=script&lang=ts"
export * from "./AgendaTable.vue?vue&type=script&lang=ts"
script.render = render

export default script